import React from 'react';
import LightText, { DarkBold, LighterBold, Lightly } from '../../Assets/CSS/Text';

const ViewModel = ({ show, onClose, employeeData }) => {
  if (!show || !employeeData) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{
          background: 'rgba(0,0,0,0.5)',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 1055,
          overflowY: 'auto',
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: '600px', width: '100%' }}
        >
          <div className="modal-content p-4 rounded-4 shadow">
            <div className="modal-header">
              <h5 className="modal-title">Task Details</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <h6 style={DarkBold}>Employee Name :<p style={LightText}>{employeeData.empName}</p> </h6>
              <h6 style={DarkBold}>Task Description :<p style={LightText}> {employeeData.taskDescription || 'N/A'}</p></h6>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewModel;
